/* eslint-disable promise/always-return */
/* eslint-disable handle-callback-err */
/* eslint-disable bam/no-react-unbound */
/* eslint-disable promise/catch-or-return */
/* eslint-disable-next-line promise/always-return*/
import { forEach, isNil } from 'lodash';
import $ from 'jquery';
import { x } from '../_helpers';
import LazyLoadService from '../_utilities/lazy-module-service';
import PlayerFavorites from './player-favorites';
import {
  rankingsFilter,
  rankingsSort,
  dashActiveClass,
  dashedSortingDeshClassName,
  lazyContentLoaded,
  seeMoreClickEvent,
  hiddenClassName,
  playersRankingsSortingClass,
  playersRankingsSortingItemClass,
  playersRankingsFiltersItemClass,
  playersRankingsHook,
  loaderClass,
  nameInputClass,
  playersRankingsPlayersItemNameClass,
  playersRankingsPlayersItemLastNameClass,
  playersRankingsPlayersItemCountryClass,
  playersRankingsPlayersItemRankingClass,
  playersRankingsPlayersItemChangeClass,
  playersRankingsCtaClass,
  playersRankingsPlayersClass,
  playersRankingsSortingItemRankingClass,
  playersRankingsNotFoundSectionClass,
  sortDirectionDesc,
  sortDirectionAsc,
  favoriteSearchButtonClass,
  justifyCenterClassName,
  enterKeyCode,
  enterKeyValue,
} from '../_helpers/constants';

export default class PlayersRankingsModule {
  constructor(_elm, opts) {
    this.opts = opts;
    this.addFavoritesText = this.opts.addFavoritesText;
    this.removeFavoritesText = this.opts.removeFavoritesText;
    this.lazyLoadService = new LazyLoadService();
    this.playerFavorites = new PlayerFavorites('', {
      addFavoritesText: this.addFavoritesText,
      removeFavoritesText: this.removeFavoritesText,
    });

    this.sortParent = x(playersRankingsSortingClass);
    this.sortItems = x(playersRankingsSortingItemClass);
    this.filterItems = x(playersRankingsFiltersItemClass);
    this.rankingsParent = document.querySelector(playersRankingsHook);
    this.spinner = this.rankingsParent.querySelector(loaderClass);

    this.nameInputElement = $(nameInputClass);

    this.rankingsContainer = $(playersRankingsHook);
    this.sortingParent = $(playersRankingsSortingClass);
    this.sortingElements = $(playersRankingsSortingItemClass);

    this.ctaHookClass = `${playersRankingsHook} ${playersRankingsCtaClass}`;

    //filters
    this.filterCategory = rankingsFilter.category.atp;
    this.filterTeamSize = rankingsFilter.teamSize.singles;
    this.filterType = rankingsFilter.type.rankings;
    this.isJustifyClass = false;

    //sorting
    this.sortType = rankingsSort.ranking;
  }

  sortByNameAsc(a, b) {
    const aChild = a.querySelector(playersRankingsPlayersItemNameClass);
    const bChild = b.querySelector(playersRankingsPlayersItemNameClass);
    return aChild.dataset.sortvalue
      .toLowerCase()
      .localeCompare(bChild.dataset.sortvalue.toLowerCase());
  }

  sortByNameDesc(a, b) {
    const aChild = a.querySelector(playersRankingsPlayersItemNameClass);
    const bChild = b.querySelector(playersRankingsPlayersItemNameClass);
    return bChild.dataset.sortvalue
      .toLowerCase()
      .localeCompare(aChild.dataset.sortvalue.toLowerCase());
  }

  sortByLastNameAsc(a, b) {
    const aChild = a.querySelector(playersRankingsPlayersItemLastNameClass);
    const bChild = b.querySelector(playersRankingsPlayersItemLastNameClass);
    return aChild.dataset.sortvalue
      .toLowerCase()
      .localeCompare(bChild.dataset.sortvalue.toLowerCase());
  }

  sortByLastNameDesc(a, b) {
    const aChild = a.querySelector(playersRankingsPlayersItemLastNameClass);
    const bChild = b.querySelector(playersRankingsPlayersItemLastNameClass);
    return bChild.dataset.sortvalue
      .toLowerCase()
      .localeCompare(aChild.dataset.sortvalue.toLowerCase());
  }

  sortByNationalityAsc(a, b) {
    const aChild = a.querySelector(playersRankingsPlayersItemCountryClass);
    const bChild = b.querySelector(playersRankingsPlayersItemCountryClass);
    return aChild.dataset.sortvalue
      .toLowerCase()
      .localeCompare(bChild.dataset.sortvalue.toLowerCase());
  }

  sortByNationalityDesc(a, b) {
    const aChild = a.querySelector(playersRankingsPlayersItemCountryClass);
    const bChild = b.querySelector(playersRankingsPlayersItemCountryClass);
    return bChild.dataset.sortvalue
      .toLowerCase()
      .localeCompare(aChild.dataset.sortvalue.toLowerCase());
  }

  sortByRankingAsc(a, b) {
    const aChild = a.querySelector(playersRankingsPlayersItemRankingClass);
    const bChild = b.querySelector(playersRankingsPlayersItemRankingClass);
    return aChild.dataset.sortvalue - bChild.dataset.sortvalue;
  }

  sortByRankingDesc(a, b) {
    const aChild = a.querySelector(playersRankingsPlayersItemRankingClass);
    const bChild = b.querySelector(playersRankingsPlayersItemRankingClass);
    return bChild.dataset.sortvalue - aChild.dataset.sortvalue;
  }

  sortByChangeAsc(a, b) {
    const aChild = a.querySelector(playersRankingsPlayersItemChangeClass);
    const bChild = b.querySelector(playersRankingsPlayersItemChangeClass);
    return bChild.dataset.sortvalue - aChild.dataset.sortvalue;
  }

  sortByChangeDesc(a, b) {
    const aChild = a.querySelector(playersRankingsPlayersItemChangeClass);
    const bChild = b.querySelector(playersRankingsPlayersItemChangeClass);
    return aChild.dataset.sortvalue - bChild.dataset.sortvalue;
  }

  manageJustifyClass() {
    const playerRankings = $(playersRankingsPlayersItemRankingClass);
    if (this.isJustifyClass) {
      playerRankings.addClass(justifyCenterClassName);
    } else {
      playerRankings.removeClass(justifyCenterClassName);
    }
  }

  setIsJustifyClass() {
    this.isJustifyClass = !!(
      this.filterTeamSize === rankingsFilter.teamSize.doubles &&
      this.filterType === rankingsFilter.type.race
    );
  }

  loadMoreData() {
    const ctaBtn = this.rankingsParent.querySelector(playersRankingsCtaClass);
    const _self = this;
    this.lazyLoadService
      .initByElement(true, ctaBtn, true)
      .then(() => {
        _self.manageJustifyClass();
        _self.playerFavorites.init();
      })
      .catch((error) => {
        return error;
      });
  }

  filterList(item) {
    const nameInputLength = this.nameInputElement.val().length;
    if (item.classList.contains('searchButton') && nameInputLength < 3 && nameInputLength !== 0) {
      return;
    }
    const rankingEntries = this.rankingsContainer.find(playersRankingsPlayersClass);
    const filterType = item.dataset.filter;
    const parentFilter = item.parentNode.dataset.filterGroup;

    //reset container
    this.rankingsContainer.find(playersRankingsNotFoundSectionClass).remove();
    this.resetSorting();
    rankingEntries.detach();

    //set spinner
    this.spinner.classList.remove(hiddenClassName);

    //set global filters
    if (parentFilter === rankingsFilter.category.name) {
      this.filterCategory = filterType;
    } else if (parentFilter === rankingsFilter.teamSize.name) {
      this.filterTeamSize = filterType;
    } else if (parentFilter === rankingsFilter.type.name) {
      this.filterType = filterType;
    }

    this.setIsJustifyClass();

    //set active class to right filter
    forEach(item.parentNode.children, function (child) {
      child.classList.remove(dashActiveClass);
    });
    if (!item.classList.contains('searchButton')) {
      item.classList.add(dashActiveClass);
    }

    //set cta json module data and trigger the load more
    const ctaEl = this.rankingsParent.querySelector(playersRankingsCtaClass);
    const ctaItem = $(this.ctaHookClass);
    let ctaJsonModule;
    let ctaJson;
    if (ctaEl) {
      ctaJsonModule = ctaEl.dataset.jsonModule;
      ctaJson = JSON.parse(ctaJsonModule);
    } else {
      ctaJson = {
        Module: { HasNextPage: false },
        Name: 'PlayersAllRankingsModule',
      };
    }

    ctaJson.Module.Skip = 0;
    ctaJson.Module.Category = this.filterCategory;
    ctaJson.Module.TeamSize = this.filterTeamSize;
    ctaJson.Module.Type = this.filterType;
    ctaJson.Module.SearchString = this.nameInputElement.val();

    ctaItem.attr('data-json-module', JSON.stringify(ctaJson));

    this.loadMoreData();
  }

  resetSorting() {
    this.sortingElements.removeClass(dashActiveClass);
    this.sortType = rankingsSort.ranking;
    this.sortingParent.find(playersRankingsSortingItemRankingClass).addClass(dashActiveClass);
  }

  setSortDirection(sortEntries, sortDirection, sortDescFn, sortAscFn) {
    if (sortDirection === sortDirectionDesc) {
      sortEntries.sort(sortDescFn);
    } else {
      sortEntries.sort(sortAscFn);
    }
  }

  sortList(item) {
    const rankingEntries = $(playersRankingsPlayersClass).get();
    const sortType = item.dataset.sorting;
    const sortDirection = item.dataset.sortingDirection;

    if (sortType === rankingsSort.lastName) {
      this.setSortDirection(
        rankingEntries,
        sortDirection,
        this.sortByLastNameDesc,
        this.sortByLastNameAsc
      );
    } else if (sortType === rankingsSort.name) {
      this.setSortDirection(rankingEntries, sortDirection, this.sortByNameDesc, this.sortByNameAsc);
    } else if (sortType === rankingsSort.nationality) {
      this.setSortDirection(
        rankingEntries,
        sortDirection,
        this.sortByNationalityDesc,
        this.sortByNationalityAsc
      );
    } else if (sortType === rankingsSort.ranking) {
      this.setSortDirection(
        rankingEntries,
        sortDirection,
        this.sortByRankingDesc,
        this.sortByRankingAsc
      );
    } else if (sortType === rankingsSort.change) {
      this.setSortDirection(
        rankingEntries,
        sortDirection,
        this.sortByChangeDesc,
        this.sortByChangeAsc
      );
    } else {
      return;
    }

    this.sortType = sortType;

    this.sortingElements.removeClass(dashActiveClass);
    item.classList.add(dashActiveClass);

    if (sortDirection === sortDirectionDesc) {
      item.classList.add(dashedSortingDeshClassName);
    } else {
      item.classList.remove(dashedSortingDeshClassName);
    }

    for (const [i, value] of rankingEntries.entries()) {
      rankingEntries[i].parentNode.appendChild(value);
    }
    const ctaEntry = $(this.ctaHookClass).get()[0];
    rankingEntries[0].parentNode.appendChild(ctaEntry);

    const extraSearch = this.rankingsContainer.find(playersRankingsNotFoundSectionClass);
    extraSearch.appendTo($(this.ctaHookClass));

    this.moveSpinnerBeforeCta();
  }

  moveSpinnerBeforeCta() {
    this.rankingsParent
      .querySelector(playersRankingsCtaClass)
      .insertAdjacentElement('beforebegin', this.spinner);
  }

  setEventListners() {
    const self = this;
    forEach(this.sortItems, (item) => {
      item.addEventListener('click', function () {
        if (item.classList.contains(dashActiveClass)) {
          const sortDirection = item.dataset.sortingDirection;

          if (sortDirection === sortDirectionAsc) {
            item.dataset.sortingDirection = sortDirectionDesc;
          } else {
            item.dataset.sortingDirection = sortDirectionAsc;
          }
        }

        self.sortList.bind(self)(item);
      });
    });

    forEach(this.filterItems, (item) => {
      item.addEventListener('click', function () {
        if (!item.classList.contains(dashActiveClass)) {
          self.filterList.bind(self)(item);
        }
      });
    });

    this.nameInputElement.on('keyup', function () {
      const name = self.nameInputElement.val();
      const searchFavoriteButton = $(favoriteSearchButtonClass)[0];

      if (name.length < 1) {
        self.filterList.bind(self)(searchFavoriteButton);
      }
    });

    this.nameInputElement.on('keypress', function (event) {
      const searchFavoriteButton = $(favoriteSearchButtonClass)[0];
      const isEnter = self.checkKeyCode(event);
      if (isEnter) {
        self.filterList.bind(self)(searchFavoriteButton);
      }
    });
  }

  checkKeyCode(event) {
    let code;

    if (!isNil(event.key)) {
      code = event.key;
    } else if (!isNil(event.keyIdentifier)) {
      code = event.keyIdentifier;
    } else if (!isNil(event.keyCode)) {
      code = event.keyCode;
    }

    if (code === enterKeyCode || code === enterKeyValue) {
      const name = this.nameInputElement.val();

      return !(isNil(name) || name === '');
    }
    return false;
  }

  setSortAfterLoadMore() {
    $(window).on(
      lazyContentLoaded,
      function () {
        //hide spinner
        this.spinner.classList.add(hiddenClassName);

        const sortItem = Array.from(this.sortParent[0].childNodes).find(
          (node) => node.dataset.sorting === this.sortType
        );
        this.sortList.bind(this)(sortItem);
      }.bind(this)
    );
  }

  showSpinnerOnSeeMoreClick() {
    $(window).on(
      seeMoreClickEvent,
      function () {
        this.spinner.classList.remove(hiddenClassName);
      }.bind(this)
    );
  }

  init() {
    this.setEventListners();
    this.setSortAfterLoadMore();
    this.showSpinnerOnSeeMoreClick();
  }
}
